{
  "sites": [
    {
      "label": "Web Config",
      "description": "Configure your SMX stages on any computer",
      "href": "https://smx.tools/"
    },
    {
      "label": "OBS Sources",
      "description": "Streamer widgets for SMX players.",
      "href": "https://obs.smx.tools/"
    },
    {
      "label": "Chart Voter",
      "description": "Vote on chart difficulty ratings",
      "href": "https://vote.smx.tools/"
    }
  ],
  "others": [
    {
      "label": "StatManiaX",
      "description": "Official score tracking website from Step Revolution",
      "href": "https://statmaniax.com/"
    },
    {
      "label": "Score Browser",
      "description": "Browse every score ever submitted with powerful processing options",
      "href": "https://smx.573.no/browser"
    },
    {
      "label": "Unplayed Tracker",
      "description": "Live-updating list of charts you haven't played yet",
      "href": "https://smx-unplayed.val.run/"
    },
    {
      "label": "SMX Stats Lookup",
      "description": "Get a nice overview of your SMX profile with a super cute theme",
      "href": "https://jacquelinett.com/smx-lookup"
    },
    {
      "label": "Personal Score Tracker",
      "description": "A mobile-friendly way to track your own high scores",
      "href": "https://smx.flag.sh/"
    },
    {
      "label": "SMX Events",
      "description": "Database of SMX tournament results",
      "href": "https://smx.events/"
    }
  ]
}
